import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import { BiTrash } from 'react-icons/bi'
import { VscDiffAdded } from 'react-icons/vsc'
import allowNumbersOnly, { handlePaste } from '../../../CommonUtils/CommonValidations'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import { useSelector } from 'react-redux'
import { GetMediumList } from '../../../Reducers/AffiliationCommonservice'
import { AC_YEAR_OLD, ERROR_MSG } from '../../../CommonUtils/contextVariables'
import { failureAlert } from '../../../CommonUtils/SweetAlerts'
import { UseGetStatus } from '../../../CommonUtils/Commonstatus'

function AffiliationforAdditionalCourses() {

    const MediumData = useSelector((state) => state?.commonMastersReducer?.Medium);
    const acYear = sessionStorage.getItem('ac_year');

    const [program, setProgram] = useState([])
    const hasFetchedData = useRef(false)
    const [course, setCourse] = useState([]);
    const [CourseCategory, setCourseCategory] = useState([]);
    const coursesFlags = useSelector((state) => state?.commonMastersReducer?.coursesFlags);
    const validation = Yup.object().shape({
        data: Yup.array().when('isAdditionalCourses', {
            is: 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    instType: Yup.string().required(ERROR_MSG).nullable(),
                    courseType: Yup.string().required(ERROR_MSG).nullable(),
                    courseId: Yup.string().required(ERROR_MSG).nullable(),
                    mediumCode: Yup.string().required(ERROR_MSG).nullable(),
                    regSelf: Yup.string().required(ERROR_MSG).nullable(),
                    courseAfflType: Yup.string().required(ERROR_MSG).nullable(),
                    addlCourseCompetentAuthAppr21: Yup.string().required(ERROR_MSG).nullable(),
                    addlCourseEoaEop21: Yup.string().required(ERROR_MSG).nullable(),
                    addlCourseCompetentAuthIntake21: Yup.string().when('addlCourseEoaEop21', {
                        is: 'true',
                        then: Yup.string().required(ERROR_MSG).nullable(),
                        otherwise: Yup.string().notRequired(),
                    }),
                    addlCourseRequestedIntake21: Yup.string().required(ERROR_MSG).nullable(),
                    approvNoOfSections: Yup.string().required(ERROR_MSG).nullable(),
                    campusType: Yup.string().required(ERROR_MSG).nullable()
                })
            ),
            otherwise: Yup.array().notRequired(),
        })
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            isAdditionalCourses: '',
            noOfCourses: '1',
            data: [{
                instType: '',
                courseType: '',
                courseId: '',
                mediumCode: '',
                regSelf: '',
                courseAfflType: '',
                addlCourseCompetentAuthAppr21: '',
                addlCourseEoaEop21: '',
                addlCourseCompetentAuthIntake21: '',
                addlCourseRequestedIntake21: '',
                approvNoOfSections: '',
                campusType: '',
            }]
        },
        validationSchema: validation,
        onSubmit: (val) => {
            if (
                val?.isAdditionalCourses === "null" ||
                val?.isAdditionalCourses === undefined ||
                val?.isAdditionalCourses === ""
            ) {
                Swal.fire({
                    title: 'Validation Required',
                    text: `plese select 'Is College Application for Affiliation of Additional Courses'`,
                    icon: 'warning',
                    backdrop: false,
                    confirmButtonText: 'OK'
                });
                return;
            }
            let payload = val?.data.map(row => ({
                ...row,
                isAdditionalCourses: val?.isAdditionalCourses,
                noOfCourses: val?.noOfCourses,
                instType: row?.instType,
                courseType: row?.courseType,
                courseId: row?.courseId,
                mediumCode: row?.mediumCode,
                regSelf: row?.regSelf,
                courseAfflType: row?.courseAfflType,
                addlCourseCompetentAuthAppr21: row.addlCourseCompetentAuthAppr21,
                addlCourseEoaEop21: row.addlCourseEoaEop21,
                addlCourseCompetentAuthIntake21: row.addlCourseCompetentAuthIntake21,
                addlCourseRequestedIntake21: row?.addlCourseRequestedIntake21,
                approvNoOfSections: row?.approvNoOfSections,
                campusType: row?.campusType
            }));


            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `saveAdditionalCourses`
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((refresh) => {
                                if (refresh.isConfirmed) {
                                    GetData();
                                    UseGetStatus();
                                }
                            })
                        }
                        else {
                            failureAlert('Failed to Submit')
                        }
                    })
                }
            })

        }
    })

    function GetData() {
        let url = `${config.url.API_URL}getAdditionalCourses`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                let data = res?.data?.getAdditionalCourses || [];
                let updatedData = data.map((ac, index) => {
                    const instType = ac?.inst_type || '';
                    const courseType = ac?.course_cat_id || '';
                    const courseId = ac?.course_id || '';
                    const addlCourseEoaEop21 = ac?.addl_course_eoa_eop_21?.toString() || 'false';
                    const addlCourseCompetentAuthIntake21 =
                        addlCourseEoaEop21 === "true" ? ac?.addl_course_competent_auth_intake_21 || '' : '';

                    if (courseType) {
                        GetCourseCategory(instType, index);
                    }
                    if (courseId) {
                        GetCourses(courseType, index);
                    }

                    return {
                        noOfCourses: res?.data?.data_count || '',
                        addlCourseCompetentAuthAppr21: ac?.addl_course_competent_auth_appr_21,
                        addlCourseEoaEop21,
                        addlCourseCompetentAuthIntake21,
                        addlCourseRequestedIntake21: ac?.addl_course_requested_intake_21,
                        approvNoOfSections: ac?.approv_no_of_sections || '',
                        instType,
                        courseType,
                        courseId,
                        regSelf: ac?.reg_self || '',
                        mediumCode: ac?.medium_code || '',
                        courseAfflType: ac?.course_affl_type || '',
                        campusType: ac?.campus_type || '',
                    };
                });
                formik.setFieldValue('data', updatedData);
                formik.setFieldValue('noOfCourses', res?.data?.data_count || 0);
            }
        });
    }


    function GetProgram() {
        let url = config.url.API_URL + `getCourseGroupList`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setProgram(res?.data?.getCourseGroupList)
            }
            else {
                setProgram([])
            }
        })
    }

    function GetCourseCategory(program, index) {
        if (!program) {
            console.log("Invalid program value:", program);
            return;
        }

        try {
            let url = `${config.url.API_URL}getCourseCategoryList/${program}`;
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    let options = res?.data?.getCourseCategoryList?.map((ds, i) => (
                        <option key={i} value={ds.course_cat_id}>{ds.course_cat_name}</option>
                    ));
                    setCourseCategory((prevState) => ({
                        ...prevState,
                        [index]: options,
                    }));
                } else {
                    setCourseCategory((prevState) => ({
                        ...prevState,
                        [index]: [],
                    }));
                }
            });
        } catch (err) {
            console.error("Error fetching course categories:", err);
        }
    }

    function GetCourses(CourseCategory, index) {
        if (!CourseCategory) {
            return;
        }
        try {
            let url = config.url.API_URL + `getSpecilization/${CourseCategory}`
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    let options = res?.data?.Specilization?.map((ds, i) => {
                        return (
                            <option key={i} value={ds.course_id}>{ds.course_name}</option>
                        );
                    });
                    setCourse((prevState) => ({
                        ...prevState,
                        [index]: options,
                    }));
                }
                else {
                    setCourse((prevState) => ({
                        ...prevState,
                        [index]: [],
                    }));
                }
            })
        } catch (err) { }
    }


    useEffect(() => {
        formik.setFieldValue('isAdditionalCourses', coursesFlags?.affl_additional_courses_flag?.toString());
        if (!hasFetchedData.current) {
            GetData()
            GetProgram()
            GetMediumList();
            hasFetchedData.current = true
        }
    }, [coursesFlags])
    const ClearValues = () => {
        const defaultValues = [{
            acYear: '',
            collCode: '',
            addlCourseCompetentAuthAppr21: '',
            addlCourseEoaEop21: '',
            addlCourseCompetentAuthIntake21: '',
            addlCourseRequestedIntake21: '',
            approvNoOfSections: '',
            noOfCourses: '',
            instType: '',
            courseType: '',
            courseId: '',
            regSelf: '',
            mediumCode: '',
            courseAfflType: '',
            campusType: ''
        }];
        formik.setFieldValue('data', defaultValues);
        formik.setFieldValue('noOfCourses', 1);
    };
    // const [courseValues, setCourseValues] = useState({});

    const handleRemoveRow = (data, index) => {
        // setCourseValues((prev) => ({
        //     ...prev,
        //     [index]: {
        //         courseType: formik.values.data[index].courseType,
        //         courseId: formik.values.data[index].courseId,
        //     },
        // }));

        const updatedCourseCategory = { ...CourseCategory };
        delete updatedCourseCategory[index];

        const rearrangeCourseType = Object.values(updatedCourseCategory).reduce((acc, item, index) => {
            acc[index] = item;
            return acc;
        }, {});

        setCourseCategory(rearrangeCourseType);

        //course, setCourse
        const updatedCourse = { ...course };
        delete updatedCourse[index];//1//

        const rearrangeCourse = Object.values(updatedCourse).reduce((acc, item, index) => {
            acc[index] = item;
            return acc;
        }, {});

        setCourse(rearrangeCourse);


        // Remove the row
        formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1);
        data.remove(index);
    };
    return (
        <>
            <FormikProvider value={formik}>
                <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >
                    <h5>3. College Application for Affiliation of Additional Courses</h5>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} className='form-control'>
                        &emsp; <label className='me-2'>
                            Is College Application for Affiliation of Additional Courses :
                        </label>
                        <div style={{ marginBottom: '8px' }}>
                            <Field as="select" name="isAdditionalCourses" className="form-control mt-2" style={{ width: 'auto' }}
                                onChange={(e) => {
                                    if (e?.target?.value === "false") { ClearValues(); }
                                }}>
                                <option value="">--select--</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </Field>
                            <ErrorMessage name="isAdditionalCourses" component="div" className="text-error" />
                        </div>
                    </div>
                    {formik.values.isAdditionalCourses === 'true' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} className='form-control'>
                                <label className='me-2'>
                                    No.of Courses * :
                                </label>
                                <Field type='text' name='noOfCourses' className='form-control' style={{ width: 'auto' }} disabled></Field></div>
                            <div className="table-responsive mt-3">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>SNO</th>
                                            <th>Academic Program Type</th>
                                            <th>Course /Program</th>
                                            <th>Branch /Combination</th>
                                            <th>Medium</th>
                                            <th>Regular/Self-Financed</th>
                                            <th>Afiliation Permanent/Temporary</th>
                                            <th>Has competent Authority( AICTE/APSCHE/BCI/PCI) Approved this course for Academic year {AC_YEAR_OLD}</th>
                                            <th>Is this course available in the Latest EOP/EOA issued by the competent Authority</th>
                                            <th>If available Please specify the Intake approved by competent Authority</th>
                                            <th>Intake being requested by College for this academic year {acYear}</th>
                                            <th>Number of Sections being requested</th>
                                            <th>Campus Type</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <FieldArray name="data">
                                            {(data) => ((data.form.values.data && data.form.values.data.length > 0 ? data.form.values.data : [{}]).map((exp, index) => (
                                                <tr key={index}>
                                                    <td><center>{index + 1}</center></td>
                                                    <td>
                                                        <div>
                                                            <Field as="select" className="form-control"
                                                                name={`data[${index}].instType`}
                                                                onChange={(e) => {
                                                                    const selectedValue = e.target.value;
                                                                    GetCourseCategory(selectedValue, index);
                                                                    formik.setFieldValue(`data[${index}].courseType`, "");
                                                                    formik.setFieldValue(`data[${index}].courseId`, "");
                                                                    // Reset dependent fields if no selection
                                                                    if (!selectedValue) {
                                                                        setCourseCategory((prevState) => ({
                                                                            ...prevState,
                                                                            [index]: [],
                                                                        }));
                                                                        setCourse((prevState) => ({
                                                                            ...prevState,
                                                                            [index]: [],
                                                                        }));

                                                                    }
                                                                }}
                                                            >
                                                                <option value=''>--select--</option>
                                                                {program && program.map((pp, i) => (
                                                                    <option value={pp?.course_group_code} key={i}>{pp?.course_group_desc}</option>
                                                                ))}
                                                            </Field>
                                                        </div>
                                                        <ErrorMessage name={`data[${index}].instType`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control" name={`data[${index}].courseType`} style={{ width: "8rem" }}
                                                            onChange={(e) => {
                                                                const selectedValue = e.target.value;
                                                                formik.setFieldValue(`data[${index}].courseId`, "");
                                                                if (!selectedValue) {

                                                                    setCourse((prevState) => ({
                                                                        ...prevState,
                                                                        [index]: [],
                                                                    }));

                                                                }
                                                                GetCourses(e.target.value, index);
                                                                formik.setFieldValue(`data[${index}].courseId`, "");

                                                            }}>
                                                            <option value="">--select--</option>
                                                            {CourseCategory[index]}
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].courseType`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control" name={`data[${index}].courseId`} style={{ width: "8rem" }}
                                                        >
                                                            <option value="">--select--</option>
                                                            {course[index]}
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].courseId`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            as="select"
                                                            className="form-control"
                                                            name={`data[${index}].mediumCode`}
                                                        >
                                                            <option value=''>--select--</option>
                                                            {MediumData && MediumData?.map((rel, i) => (
                                                                <option value={rel?.medium_code}>{rel?.name}</option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].mediumCode`} component="div" className="text-error" />
                                                    </td>

                                                    <td>
                                                        <Field
                                                            as="select"
                                                            className="form-control"
                                                            name={`data[${index}].regSelf`}>
                                                            <option value="">--select--</option>
                                                            <option value="R">Regular</option>
                                                            <option value="S">Self-Financed</option>
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].regSelf`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control" name={`data[${index}].courseAfflType`} style={{ width: "8rem" }}>
                                                            <option value="">--select--</option>
                                                            <option value="Permanent">Permanent</option>
                                                            <option value="Temporary">Temporary</option>
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].courseAfflType`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control" style={{ width: "6rem" }}
                                                            name={`data[${index}].addlCourseCompetentAuthAppr21`}>
                                                            <option value="">--select--</option>
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option>
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].addlCourseCompetentAuthAppr21`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            as="select"
                                                            className="form-control"
                                                            name={`data[${index}].addlCourseEoaEop21`}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                formik.setFieldValue(`data[${index}].addlCourseEoaEop21`, value);

                                                                if (value === "false") {
                                                                    formik.setFieldValue(`data[${index}].addlCourseCompetentAuthIntake21`, '');
                                                                }
                                                            }}
                                                        >
                                                            <option value="">--select--</option>
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option>
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].addlCourseEoaEop21`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        {formik.values.data[index].addlCourseEoaEop21 === "true" && (
                                                            <>
                                                                <Field
                                                                    type="text" onPaste={(e) => handlePaste(e)}
                                                                    className="form-control"
                                                                    name={`data[${index}].addlCourseCompetentAuthIntake21`}
                                                                    maxLength="4"
                                                                    onKeyPress={(e) => allowNumbersOnly(e)}
                                                                />
                                                                <ErrorMessage name={`data[${index}].addlCourseCompetentAuthIntake21`} component="div" className="text-error" />
                                                            </>
                                                        )}
                                                    </td>

                                                    <td>
                                                        <Field
                                                            type="text" onPaste={(e) => handlePaste(e)}
                                                            className="form-control"
                                                            name={`data[${index}].addlCourseRequestedIntake21`} maxLength='4'
                                                            onKeyPress={(e) => { allowNumbersOnly(e) }}
                                                        />
                                                        <ErrorMessage name={`data[${index}].addlCourseRequestedIntake21`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            type="text" onPaste={(e) => handlePaste(e)}
                                                            className="form-control"
                                                            name={`data[${index}].approvNoOfSections`}
                                                            maxLength='1'
                                                            onKeyPress={(e) => { allowNumbersOnly(e) }}
                                                        />
                                                        <ErrorMessage name={`data[${index}].approvNoOfSections`} component="div" className="text-error" />
                                                    </td>
                                                    <td>
                                                        <Field as="select" className="form-control" name={`data[${index}].campusType`} style={{ width: "8rem" }}>
                                                            <option value="">--Select--</option>
                                                            <option value="main">Main Campus</option>
                                                            <option value="off">Off Campus</option>
                                                        </Field>
                                                        <ErrorMessage name={`data[${index}].campusType`} component="div" className="text-error" />
                                                    </td>
                                                    <td align="center">
                                                        {index === 0 ? (
                                                            <button
                                                                type="button"
                                                                className="button-titile btn btn-sm btn-success"
                                                                onClick={() => {
                                                                    formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) + 1)
                                                                    data.push({
                                                                        acYear: '',
                                                                        collCode: '',
                                                                        addlCourseCompetentAuthAppr21: '',
                                                                        addlCourseEoaEop21: '',
                                                                        addlCourseCompetentAuthIntake21: '',
                                                                        addlCourseRequestedIntake21: '',
                                                                        approvNoOfSections: '',
                                                                        noOfCourses: '',
                                                                        instType: '',
                                                                        courseType: '',
                                                                        courseId: '',
                                                                        regSelf: '',
                                                                        mediumCode: '',
                                                                        courseAfflType: '',
                                                                        campusType: ''
                                                                    });
                                                                }}
                                                            >
                                                                <VscDiffAdded></VscDiffAdded>{" "}
                                                            </button>
                                                        ) : ""}
                                                        {index !== 0 ? (
                                                            <button
                                                                type="button"
                                                                className="button-titile btn btn-sm btn-danger"
                                                                onClick={() => {
                                                                    handleRemoveRow(data, index);
                                                                    // data.remove(index);
                                                                    // formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1)
                                                                }}
                                                            >
                                                                <BiTrash></BiTrash>
                                                            </button>
                                                        ) : ""}
                                                    </td>
                                                </tr>
                                            ))
                                            )}
                                        </FieldArray>
                                    </tbody>
                                </table>
                            </div>
                        </>)}
                    <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />
                </Form>
            </FormikProvider>
        </>
    )
}

export default AffiliationforAdditionalCourses
